/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/dropdownmenuitem/dropdownmenuitem_styles';



/* ========== ~~~~~~~~~~ LABEL ASSIGNMENT FIELD  : DROPDOWN ITEM ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {

    let { itemName, itemValue, searchTerm } = props;

    const renderItemText = () => {
        let beginningText = itemName.slice(0,itemName.toLowerCase().indexOf(searchTerm.toLowerCase()));
        let highlightedText = itemName.slice(itemName.toLowerCase().indexOf(searchTerm.toLowerCase()), itemName.toLowerCase().indexOf(searchTerm.toLowerCase()) + searchTerm.length);
        let endingText = itemName.slice(itemName.toLowerCase().indexOf(searchTerm.toLowerCase()) + searchTerm.length, itemName.length);
        return(
            <div className={'itemtext'}>
                <span>{beginningText}</span><span className={`highlight`} >{highlightedText}</span><span>{endingText}</span>
            </div>
        )
    };

    return (
        <div className={`dropdownmenuitem ${props.classes.dropdownmenuitem}`} onClick={() => props.handleSelect(itemValue)}>
            {renderItemText()}
        </div>
    );
});
